import { Pipe, PipeTransform } from '@angular/core';
import {
    IConfigurableTable,
    IConfigurableTableColumnHmpr,
    IConfigurableTableHmpr
} from "libraries/interfaces/i-configurable-table";

@Pipe({
    name: 'findColInConfig'
})

export class FindColInConfigPipe implements PipeTransform {
    public transform(configuration: IConfigurableTableHmpr | IConfigurableTable, key: string): IConfigurableTableColumnHmpr {
        return configuration.columnArray
            .find((col:IConfigurableTableColumnHmpr): boolean => col.key === key) as IConfigurableTableColumnHmpr;
    }
}
